<!-- Werkzeugleiste exakt nach der Allow-List (Client-Dok §8.1): kein H1 (Ebene 1 ist der
     Nachrichtentitel), kein Unterstreichen, kein Durchstreichen, kein Code. Was hier fehlt,
     kann auch ueber Tastatur oder Einfuegen nicht entstehen — die Extensions dafuer sind gar
     nicht geladen. -->
@if (label) {
  <label>{{ label | translate }}</label>
}

<div class="editorWrapper flex flex-col w-full">
  <div class="p-1 flex buttons w-full gap-1">
    <button type="button" id="bold" [disabled]="disabled" [ngClass]="{ 'active': isActive('bold') }"
            [title]="'core.announcement.form.editor.bold' | translate"
            (click)="toggle('bold')">B</button>
    <button type="button" id="italic" [disabled]="disabled" [ngClass]="{ 'active': isActive('italic') }"
            [title]="'core.announcement.form.editor.italic' | translate"
            (click)="toggle('italic')">I</button>
    <button type="button" id="h2" [disabled]="disabled" [ngClass]="{ 'active': isActive('heading', { level: 2 }) }"
            [title]="'core.announcement.form.editor.heading2' | translate"
            (click)="toggleHeading(2)">H2</button>
    <button type="button" id="h3" [disabled]="disabled" [ngClass]="{ 'active': isActive('heading', { level: 3 }) }"
            [title]="'core.announcement.form.editor.heading3' | translate"
            (click)="toggleHeading(3)">H3</button>
    <button type="button" id="bulletList" [disabled]="disabled" [ngClass]="{ 'active': isActive('bulletList') }"
            [title]="'core.announcement.form.editor.bulletList' | translate"
            (click)="toggle('bulletList')">•</button>
    <button type="button" id="orderedList" [disabled]="disabled" [ngClass]="{ 'active': isActive('orderedList') }"
            [title]="'core.announcement.form.editor.orderedList' | translate"
            (click)="toggle('orderedList')">1.</button>
    <button type="button" id="blockquote" [disabled]="disabled" [ngClass]="{ 'active': isActive('blockquote') }"
            [title]="'core.announcement.form.editor.blockquote' | translate"
            (click)="toggle('blockquote')">&rdquo;</button>
    <button type="button" id="link" [disabled]="disabled" [ngClass]="{ 'active': isActive('link') }"
            [title]="'core.announcement.form.editor.link' | translate"
            (click)="setLink()">&#128279;</button>
  </div>

  <div #editorElement class="editor w-full"></div>
</div>

<!-- Zaehler und Sperre kommen aus derselben Funktion (richTextLength) — sie koennen nicht
     auseinanderlaufen. -->
<div data-testid="char-count"
     class="text-[13px]"
     [ngClass]="overLimit ? 'text-[#c0123c]' : 'text-[#848488]'">
  {{ 'core.announcement.form.editor.charCount' | translate:{ count: charCountFormatted, max: maxCharsFormatted } }}
</div>
